/*
 * @Author: fengqianhui
 * @Date: 2024-01-10 09:34:58
 * @LastEditors: 18518155760 111m
 * @LastEditTime: 2024-01-12 15:26:07
 * @FilePath: \landingpage\src\stores\originDataStore.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { defineStore } from 'pinia';
import { ProjectData } from '@/types/data'; // 确保路径正确
import { getOriginData } from '@/api/download';

export const useOriginDataStore = defineStore('originData', {
  state: () => ({
    data: null as ProjectData | null,
  }),
  actions: {
    async fetchOriginData(taskId: string) {
      try {
        const response = await getOriginData({ taskId });
        this.data = response.data;
      } catch (error) {
        console.error('Failed to fetch origin data:', error);
      }
    },
  },
});
